import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { ZSetUserPropertyBulkBody, ZSetUserPropertyBulkResponse } from './models';

const c = initContract();

const ZBadRequest = z.object({ message: z.string() });

// ─── Contract ─────────────────────────────────────────────────────────────────
export const adminAnalyticsContract = c.router(
  {
    setUserPropertyBulk: {
      method: 'POST',
      path: '/users/properties/bulk',
      body: ZSetUserPropertyBulkBody,
      responses: {
        200: ZSetUserPropertyBulkResponse,
        400: ZBadRequest,
      },
      summary: 'Set a single user property across many Analytics profiles',
    },
  },
  {
    pathPrefix: '/admin',
    commonResponses: {
      401: c.type<{ message: string; statusCode: 401 }>(),
    },
  },
);
